// Curated from Twilio's own documentation. Kept short and free of
// provider/technical branding — this text is shown directly to shop staff,
// not developers. The raw code is still tracked internally (visible via the
// title/hover tooltip) in case it's ever needed for support purposes.
// Each line says what happened AND, where there is one, what staff can do
// about it -- "not delivered" on its own leaves the counter guessing whether to
// resend, call the customer, or fix the number.
//
// 26 Sep: the carrier codes (30003-30007) were missing entirely, which are
// the ones a shop actually sees -- a mistyped or landline number is by far the
// most common failure. Sale 16457's receipt failed with 30005 and the screen
// could only say "could not be delivered." Codes checked against Twilio's
// error reference (twilio.com/docs/api/errors).
const FAILURE_REASON_MESSAGES = {
  // The customer's number
  '21211': "This isn't a valid phone number. Check the customer's number in Lightspeed.",
  '21614': "This number can't receive texts (usually a landline). Check the customer's number in Lightspeed.",
  '30003': "The customer's phone was off or out of signal. Try again later.",
  '30005': "This number doesn't exist or can't receive texts. Check the customer's number in Lightspeed.",
  '30006': "This number is a landline or can't receive texts. Check the customer's number in Lightspeed.",
  '21610': 'This customer replied STOP and has opted out of texts from the shop.',
  '30004': "The customer's phone or carrier blocked this message.",

  // The phone company
  '30007': 'The phone company filtered this message as possible spam.',
  '30008': 'Delivery failed for an unknown reason.',
  '30410': 'The phone company timed out delivering it. Try sending again.',
  '30001': 'Too many messages were queued at once. Try sending again.',

  // Attachments
  '11200': 'The picture could not be fetched in time. Try sending again.',
  '11751': 'The attachment was too large to send.',
  '12300': "The attachment's file type isn't supported.",
  '21620': 'The attachment link expired before it could be sent.',
  '30011': "The recipient's phone doesn't support picture or video messages.",
  '30019': 'The attachment was too large for the recipient\u2019s carrier network.',
  '63019': 'The attachment could not be downloaded before sending.',
  '63034': 'The attachment was too large for this type of message.',
  '30015': "This message type isn't supported.",

  // The shop's texting setup -- not something the counter can fix
  '21606': "The shop's texting number can't send to this destination.",
  '30002': "The shop's texting account is suspended. Contact Spinboard support.",
  '30022': 'The shop is sending too quickly for the carriers. Try again in a minute.',
  '30023': 'Daily texting limit reached. Try again tomorrow.',
  '30027': 'Daily limit for T-Mobile customers reached. Try again tomorrow.',
  '30032': "The shop's number is still pending verification.",
  '30033': "The shop's texting registration is suspended. Contact Spinboard support.",
  '30034': "The shop's texting number isn't registered with the carriers yet.",
  '30035': "The shop's texting number is still being set up with the carriers.",
  '30037': "Sending is turned off on the shop's texting account. Contact Spinboard support.",
  '30042': 'The sending number was flagged as suspicious by the carrier.',
};

// A code this list does not know still shows its number, so staff (and
// support) have something to look up instead of a sentence that says nothing.
export function getTwilioErrorText(code) {
  if (!code) return 'The message could not be delivered.';
  return FAILURE_REASON_MESSAGES[String(code)] || `The message could not be delivered (error ${code}).`;
}

export const KNOWN_TWILIO_ERROR_CODES = Object.keys(FAILURE_REASON_MESSAGES);
